export default __webpack_public_path__ + "static/media/logo.a03ddcd7.webp";